var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRequests(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 9.33341H24C23.2928 9.33341 22.6145 9.05246 22.1144 8.55237C21.6143 8.05227 21.3333 7.37399 21.3333 6.66675V2.66675M9.33333 10.6667V22.4001C9.33333 22.8001 9.6 23.2001 9.86667 23.4667C10.1333 23.7334 10.5333 24.0001 10.9333 24.0001H20M4 16.0001V27.7334C4 28.1334 4.26667 28.5334 4.53333 28.8001C4.8 29.0667 5.2 29.3334 5.6 29.3334H14.6667M28 8.00008V16.6667C28 17.7334 27.0667 18.6667 26 18.6667H16.6667C15.6 18.6667 14.6667 17.7334 14.6667 16.6667V4.66675C14.6667 3.60008 15.6 2.66675 16.6667 2.66675H22.6667L28 8.00008Z",
    stroke: "url(#paint0_linear_1_299)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_299",
    x1: 4,
    y1: 16.0001,
    x2: 28,
    y2: 16.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7334"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRequests);
export default __webpack_public_path__ + "static/media/icon-requests.1a4f092c8ffe4f4a28d256d0213ab4e1.svg";
export { ForwardRef as ReactComponent };